import getEnvValue from './getEnvValue';

function isTestEnv() {
  return getEnvValue('JB_TEST_ENV') === 'jest';
}

export default isTestEnv;
